import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
export var EStatus;

(function (EStatus) {
  EStatus[EStatus["PENDING"] = 0] = "PENDING";
  EStatus[EStatus["WORKING"] = 1] = "WORKING";
})(EStatus || (EStatus = {}));

export var State = /*#__PURE__*/function () {
  function State() {
    _classCallCheck(this, State);

    _defineProperty(this, "status", EStatus.PENDING);
  }

  _createClass(State, [{
    key: "getStatus",
    value: function getStatus() {
      return this.status;
    }
  }, {
    key: "setPending",
    value: function setPending() {
      this.status = EStatus.PENDING;
    }
  }, {
    key: "setWorking",
    value: function setWorking() {
      this.status = EStatus.WORKING;
    }
  }, {
    key: "isPending",
    value: function isPending() {
      return this.status === EStatus.PENDING;
    }
  }, {
    key: "isWorking",
    value: function isWorking() {
      return this.status === EStatus.WORKING;
    }
  }]);

  return State;
}();